<template>

</template>

<script>
export default {
  props: ["value"],
}
</script>
